import Navigation from "@/components/Navigation";
import Hero from "@/components/Hero";
import AboutSection from "@/components/AboutSection";
import Services from "@/components/Services";
import AgentCard from "@/components/AgentCard";
import Testimonials from "@/components/Testimonials";

import Contact from "@/components/Contact";
import Footer from "@/components/Footer";

const Index = () => {
  return (
    <div className="min-h-screen bg-background">
      <Navigation />
      <Hero />
      <AboutSection />
      <Services />
      <AgentCard />
      <Testimonials />
      
      <Contact />
      <Footer />
    </div>
  );
};

export default Index;
